"use client";
import type { FC, HTMLProps } from "react";

import STYLES from "@vita-learning/styles";

import Button, { type ButtonProps } from "./Button";

const { normal, interaction } = STYLES.colors.lights.backgrounds.cancels;

export const CancelButton: FC<
	Omit<HTMLProps<HTMLButtonElement>, keyof ButtonProps> & ButtonProps
> = ({ children, ...props }) => (
	<Button {...props} color={normal} pseudoColor={interaction}>
		{children}
	</Button>
);
